import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Modal, SaButton, StatusPill, errMsg } from './ui';
import { SettingsEditor, SECTION_META } from './SettingsEditor';

export const CompanySetupModal = ({ company, onClose, onChanged }) => {
  const [payload, setPayload] = useState(null);
  const base = `/superadmin/companies/${company.id}/settings`;
  const load = () => axios.get(base).then((r) => setPayload(r.data)).catch(() => toast.error('Could not load settings'));
  useEffect(() => { load(); }, [company.id]); // eslint-disable-line

  const activate = async () => {
    try { await axios.post(`/superadmin/companies/${company.id}/activate`); toast.success(`${company.name} is now active`); onChanged(); onClose(); }
    catch (e) { toast.error(errMsg(e, 'Activation failed')); }
  };

  return (
    <Modal title={`${company.name} · Company Setup`} onClose={onClose} width={1100} testId="company-setup-modal">
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 16 }}>
        <StatusPill status={company.status} />
        <span style={{ color: '#A1A1AA', fontSize: 13 }}>/{company.slug}</span>
        {company.status === 'onboarding' && <SaButton data-testid="activate-company-btn" onClick={activate} style={{ marginLeft: 'auto' }}>Activate company</SaButton>}
      </div>
      {payload ? (
        <SettingsEditor baseUrl={base} logoUrl={`${base}/logo`} sections={Object.keys(SECTION_META)} initial={payload.settings} companyId={company.id} onSaved={onChanged} />
      ) : <p style={{ color: '#A1A1AA' }}>Loading…</p>}
    </Modal>
  );
};
